const i18nKeyPrefix = 'uScope.extensions.snapshot';

export const DEFAULT_FILE_NAME = 'LeicaWebViewerSnapshot.jpg';

export const CSS_CLASS_NAMES = {
  MODE_BUTTONS: 'snapshot-mode-options',
  DESTINATION_BUTTONS: 'snapshot-destination-options',
  SIZE_OPTIONS: 'snapshot-size-options',
  DISABLED: 'snapshot-settings-disabled',
  VALIDATION_ERROR: 'lbs-validation-error',
  CANVAS_BASE_CLASS: 'us-snapshot-drawing-overlay'
};

export const ANIMATE_SPEED = {
  ASCENDING: 0.1,
  DESCENDING: -0.15
};

export const SNAPSHOT_DRAW_BACKGROUND_COLOR = 'rgba(255, 255, 255, 0.6)';

/**
 * Drawable mode.
 */
export const MODES = {
  /**
   * WYSIWYG mode just captures what's on the current view.
   */
  WYSIWYG: 'wysiwyg',
  /**
   * Fixed mode captures a fixed-size area.
   */
  FIXED: 'fixed',
  /**
   * Allows the user to draw a rectangle on the viewport.
   */
  RESIZABLE: 'resizable',
  /**
   * Also allows the user to draw a rectangule on the viewport; aspect ratio is fixed.
   */
  FIXED_ASPECT: 'fixed-aspect'
};

/**
 * Lookup table defining whether the various modes require dimensions to be set.
 * @type {{}}
 */
export const needsDimensions = {
  [MODES.WYSIWYG]: false,
  [MODES.FIXED]: true,
  [MODES.FIXED_ASPECT]: true,
  [MODES.RESIZABLE]: false
};

export const MODE_NAMES = {
  [MODES.WYSIWYG]: `${i18nKeyPrefix}.full-view`,
  [MODES.FIXED]: `${i18nKeyPrefix}.fixed-size`,
  [MODES.RESIZABLE]: `${i18nKeyPrefix}.resizable`,
  [MODES.FIXED_ASPECT]: `${i18nKeyPrefix}.fixed-aspect`
};

/**
 * Text and words.
 */
export const modeInfo = {
  [MODES.WYSIWYG]: `${i18nKeyPrefix}.full-view-description`,
  [MODES.FIXED]: `${i18nKeyPrefix}.fixed-size-description`,
  [MODES.RESIZABLE]: `${i18nKeyPrefix}.resizable-description`,
  [MODES.FIXED_ASPECT]: `${i18nKeyPrefix}.fixed-aspect-description`
};

/**
 * The maximum width servable by image server
 * @type {number}
 */
export const MAX_WIDTH = 2000;
/**
 * The maximum height servable by image server
 * @type {number}
 */
export const MAX_HEIGHT = 2000;

export const DESTINATIONS = {
  CLIENT: 'client',
  SERVER: 'server'
};

export const destinationInfo = {
  [DESTINATIONS.CLIENT]: `${i18nKeyPrefix}.local-description`,
  [DESTINATIONS.SERVER]: `${i18nKeyPrefix}.remote-description`
};

/**
 * Baseline settings.
 */
export const defaultSettings = {
  /**
   * Capture mode: Whether or not to capture at the current resolution. No scaling will occur.
   */
  mode: MODES.WYSIWYG,
  /**
   * The height of the captured image.
   */
  height: 1600,
  /**
   * The width of the captured image.
   */
  width: 1600,

  destination: DESTINATIONS.CLIENT
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/settings/constants.js